export default {
  areaID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  mnemonic: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/schedulingcontact/schedulingcontact-form.js